import styled from 'styled-components';
import { AccordionVersionModel } from '../accordion.model';
import { getAccordionItemStyle } from './accordionItem.mixin';

export const AccordionItemStyled = styled.div<{
  version: AccordionVersionModel;
}>`
  ${({ theme, version }) => getAccordionItemStyle(theme, version)};
`;
